import axios from 'axios';

const REGEX_CAPTURE_GROUP_INDEX = 1;

export const validatePluginContent = async (
  url: string,
): Promise<{ name: string; version: string }> => {
  try {
    const response = await axios.get(url);
    const content = response.data;

    const nameMatch = content.match(/pluginName\s*=\s*['"]([^'"]+)['"]/);
    const name = nameMatch?.[REGEX_CAPTURE_GROUP_INDEX];

    const versionMatch = content.match(/pluginVersion\s*=\s*['"]([^'"]+)['"]/);
    const version = versionMatch?.[REGEX_CAPTURE_GROUP_INDEX];

    if (!name || !version) {
      throw new Error('Plugin name or version not found in the plugin file');
    }

    return { name, version };
  } catch (error) {
    throw new Error(error instanceof Error ? error.message : 'Failed to validate plugin content');
  }
};
